import { storage } from "components/common";

const TOKEN_STORAGE_KEY = "authToken";

const [fetchToken, storeToken] = storage(TOKEN_STORAGE_KEY);

export default { fetchToken, storeToken };
